import React from 'react';
import { FaChartLine, FaFileInvoiceDollar, FaCalculator, FaDatabase, FaShieldAlt, FaRobot } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './ServicesPreview.css';

const ServicesPreview = () => {
  const navigate = useNavigate();

  const services = [
    { icon: <FaRobot />, title: 'Automation Solutions', description: 'BOTs that streamline verification and compliance checks' },
    { icon: <FaShieldAlt />, title: 'IT Audit & Security', description: 'Evaluate and strengthen information systems for resilience' },
    { icon: <FaCalculator />, title: 'Accounting Services', description: 'Reliable, accurate, and audit-ready accounting services' },
    { icon: <FaDatabase />, title: 'Data Analytics & BI', description: 'Transform data into meaningful insights for strategic decisions' },
    { icon: <FaChartLine />, title: 'Audit & Assurance', description: 'Comprehensive audit services with emphasis on independence and technical accuracy' },
    { icon: <FaFileInvoiceDollar />, title: 'Tax Advisory', description: 'Tailored tax solutions for individuals, corporates, and organizations' }
  ];

  const navigateToServices = () => {
    navigate('/services');
  };

  return (
    <section className="services-preview section">
      <div className="container">
        <div className="section-header center animate-on-scroll">
          <span className="section-label">What We Do</span>
          <h2>Our Core Services</h2>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card animate-on-scroll">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
        <div className="center">
          <button className="btn-primary" onClick={navigateToServices}>View All Services</button>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
